import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Atoms/Icon/Icon'
import { CTA } from '../../Atoms';
import { RawHtml } from '../../Utilities';

const Headline = ({ value }) => {
  if (!value) return null;
  
  const { heading, headingLabel, subHeading, intro, cta, icon, darkBackground } = value;
  
  return (
    <section className={`section section-full ${darkBackground ? 'context-dark' : ''}`}>
      <div className="section__inner">
        {/* TEMPORARY FIX: Retains full layout bounds and completely strips out visible elevator bar tracks */}
        <div 
          className="viewport-90" 
          style={{ 
            maxHeight: 'calc(100vh - 128px)', 
            overflowY: 'scroll',          /* Keeps text scrollable if screen gets tiny */
            scrollbarWidth: 'none',       /* Hides track in Firefox */
            msOverflowStyle: 'none'       /* Hides track in IE/Edge */
          }}
        >
          {/* Webkit support block to cleanly force Chrome, Safari, and Mozilla panels to hide the tracks */}
          <style>{`
            .viewport-90::-webkit-scrollbar {
              display: none !important;   /* Hides track in Chrome/Safari/Opera */
              width: 0 !important;
              height: 0 !important;
            }
          `}</style>
          
          {/* CHANGED: content-element instead of block structure */}
          <div className="content-element content-element-flush">
            {/* FIX: Added items-start and text-left to force left-alignment on all elements */}
            <div className="stack stack-normal items-start text-left">
              {icon?.iconName && (
                <Icon
                  name={icon.iconName}
                  library={icon.library}
                  className="icon-2xl"
                />
              )}
              {headingLabel && <div className="text-label">{headingLabel}</div>}
              {heading && <div className="text-section-title">{heading}</div>}
              {subHeading && <div className="text-section-support">{subHeading}</div>}
              {intro && (
                <div className="text-body">
                  <RawHtml html={intro} />
                </div>
              )}
              {cta?.text && cta?.url && (
                <div>
                  <a href={cta.url} className="btn btn-primary btn-lg">{cta.text}</a>
                </div>
              )}
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

Headline.propTypes = {
  value: PropTypes.shape({
    headingLabel: PropTypes.string,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    intro: PropTypes.string,
    cta: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    }),
    icon: PropTypes.shape({
      iconName: PropTypes.string,
      library: PropTypes.string,
    }),
    darkBackground: PropTypes.bool,
  }),
};

export default Headline;
